module.exports = new __parcel__URL__("tree.e62f2602.svg").toString();